var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dialog",
    {
      staticClass: "gt-card",
      attrs: { open: "", "aria-live": "polite", "aria-label": _vm.titulo }
    },
    [
      _c("div", { staticClass: "gt-card__topo" }, [
        !_vm.noDesfecho
          ? _c("span", { staticClass: "gt-card__progresso az-ds-aux" }, [
              _vm._v(" " + _vm._s(_vm.rotuloDoProgresso) + " ")
            ])
          : _c("span", { staticClass: "gt-card__progresso az-ds-aux" }, [
              _vm._v("Etapa concluída")
            ]),
        _c("div", { staticClass: "gt-card__topo-acoes" }, [
          !_vm.noDesfecho
            ? _c(
                "button",
                {
                  staticClass: "gt-card__passo-a-passo az-ds-aux",
                  attrs: { type: "button", "aria-label": _vm.rotuloDoDrawer },
                  on: {
                    click: function($event) {
                      return _vm.$emit("alternar-drawer")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.rotuloDoDrawer) + " ")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "gt-card__fechar",
              attrs: {
                type: "button",
                "aria-label": "Encerrar a jornada guiada"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("fechar")
                }
              }
            },
            [
              _c("icon-svg", {
                attrs: {
                  name: "close",
                  size: "12",
                  color: "var(--neutral-600)"
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("h3", { staticClass: "gt-card__titulo az-ds-card-title" }, [
        _vm._v(_vm._s(_vm.titulo))
      ]),
      _vm.detalhe
        ? _c("p", { staticClass: "gt-card__detalhe az-ds-body" }, [
            _vm._v(_vm._s(_vm.detalhe))
          ])
        : _vm._e(),
      _vm.noDesfecho
        ? _c(
            "div",
            { staticClass: "gt-card__marcar" },
            [
              _c("input-by-type", {
                attrs: {
                  type: "checkbox",
                  value: _vm.marcarConcluida,
                  label: "Marcar esta etapa como concluída",
                  "hide-details": ""
                },
                on: { input: _vm.aoAlternarMarcacao }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.noDesfecho && _vm.total > 1
        ? _c(
            "div",
            { staticClass: "gt-card__pontos" },
            _vm._l(_vm.pontos, function(ponto) {
              return _c("span", {
                key: ponto.indice,
                staticClass: "gt-card__ponto",
                class: {
                  "gt-card__ponto--ativo": ponto.ativo,
                  "gt-card__ponto--feito": ponto.feito
                }
              })
            }),
            0
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "gt-card__acoes", class: _vm.classesDasAcoes },
        [
          _vm.noDesfecho
            ? [
                _vm.temProxima
                  ? _c(
                      "BaseButton",
                      {
                        attrs: { primary: "", loading: _vm.marcando },
                        on: {
                          click: function($event) {
                            return _vm.$emit("proxima-etapa")
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.rotuloDaProxima) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "BaseButton",
                  {
                    attrs: {
                      primary: !_vm.temProxima,
                      underlined: _vm.temProxima,
                      loading: _vm.marcando && !_vm.temProxima
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("fechar")
                      }
                    }
                  },
                  [_vm._v(" Encerrar por aqui ")]
                )
              ]
            : [
                !_vm.ehPrimeiroPasso
                  ? _c(
                      "BaseButton",
                      {
                        attrs: { underlined: "" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("anterior")
                          }
                        }
                      },
                      [_vm._v(" Voltar ")]
                    )
                  : _vm._e(),
                _vm.aguardaAcao
                  ? _c(
                      "span",
                      { staticClass: "gt-card__aguardando az-ds-aux" },
                      [_vm._v(" " + _vm._s(_vm.TEXTO_AGUARDANDO) + " ")]
                    )
                  : _c(
                      "BaseButton",
                      {
                        attrs: { primary: "" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("proximo")
                          }
                        }
                      },
                      [_vm._v(" Próximo ")]
                    )
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }